import { z } from "zod/v4";

import { OrganizationSummaryDtoSchema } from "../../../dtos/organization-summaries";

export const GetOrganizationSummariesRequestQueryParamSchema = z.object({
  limit: z.number().optional(),
});

export const GetOrganizationSummariesResponseBodySchema = z.object({
  orgs: OrganizationSummaryDtoSchema.array(),
});

export type GetOrganizationSummariesRequestQueryParamType = z.infer<
  typeof GetOrganizationSummariesRequestQueryParamSchema
>;
export type GetOrganizationSummariesResponseBodyType = z.infer<
  typeof GetOrganizationSummariesResponseBodySchema
>;
